import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PrinterSettings, PrinterSettingsData } from '../../../../@core/interfaces/masters/printersettings';
import { commonsettings } from '../../../../data/ezoTempSettings';



@Injectable({
  providedIn: 'root'
})
export class PrintServiceService {
  private tenantId = localStorage.getItem("tenantId");
  private branchId = localStorage.getItem("branchId");

  bloomTID="6bca4d90-c7f3-4f2c-c4d5-08d8d1941782";
  bloomBID="9c389042-8029-4cd0-3554-08d8d1941802";
  listPrint=null;
  listname=null;
  
  psDetails:PrinterSettings;
  protected readonly unsubscribe$ = new Subject<void>();
  objectKeys = Object.keys;

  constructor(public psSrvc:PrinterSettingsData) { }

  async printLabel(content, psDetails) {
    var styleUrl=`<link rel='stylesheet' href="/assets/css/print.css">`;
    var size="6cm 3cm";
    psDetails.topMargin='-2';
    psDetails.leftMargin='-5';
    psDetails.pageSetupFor="Lab";
    this.openPrintWindow(content,psDetails,size,styleUrl,'0','13','');
  }

  async printBarcode(content, psDetails,width,height) {
    var styleUrl=`<link rel='stylesheet' href="/assets/css/print.css">`;
    var size=`${!!width?width:100}mm ${!!height?height:50}mm`;
    psDetails.topMargin='0';
    psDetails.leftMargin='0';
    psDetails.pageSetupFor="Lab";
    this.openBarPrintWindow(content,psDetails,size,styleUrl,'0','13','',width,height);
  }

  async stickerPrint(content, psDetails,width,height,tm,lm) {
    var styleUrl=`<link rel='stylesheet' href="/assets/css/stickertmpl.css">`;
    var size=`${!!width?width:100}mm ${!!height?height:50}mm`;
    psDetails.topMargin=0;
    psDetails.leftMargin=lm;
    psDetails.pageSetupFor="Lab";
    this.openBarPrintWindow(content,psDetails,size,styleUrl,'0','13','',width,height,tm,lm);
  }

  
  printConfig(psDetails){ 
        var size = psDetails?.paperSize?.toUpperCase() + ' ' + psDetails?.orientation; 
        var styleUrl=[...commonsettings.styleUrls];

        styleUrl.push({ rel: 'stylesheet', href: '/assets/css/print.css' });
        if(psDetails?.paperSize == "custom"){
          if(psDetails.height==15&&psDetails.width==15){
            styleUrl.push({ rel: 'stylesheet', href: '/assets/css/a5landscape.css' });
          }else{
            styleUrl.push({ rel: 'stylesheet', href: '/assets/css/printcustom.css' });
          }  
        }else if (psDetails?.paperSize == "A5") {
            styleUrl.push({ rel: 'stylesheet', href: '/assets/css/printcustom.css' });
            styleUrl.push({ rel: 'stylesheet', href: '/assets/css/a5portrait.css' });
        }

        var styles=`
        @media print { 
          @page
          { 
            size: ${size} !important;
            margin: ${psDetails?.topMargin}px ${psDetails?.rightMargin}px ${psDetails?.bottomMargin}px ${psDetails?.leftMargin}px !important;
          }
        `;
        return {
            printMode: 'template-popup',
            popupProperties: 'toolbar=yes,scrollbars=yes,resizable=yes,top=0,left=0,fullscreen=yes',
            pageTitle: psDetails?.pageSetupFor,
            stylesheets: styleUrl,
            styles: [ 
              commonsettings.printCommonStyle,styles
            ]
      };

  }
  async printPage(content, psDetails) {    
    var size="";
    var margin="";
    var tblPadding="0.2";
    var fontSize=13;
    var height="auto";
    var width="auto";
    var a5style='';
    
    var styleUrl=`<link rel='stylesheet' href="/assets/css/print.css">`;
    var chai=psDetails?.pageSetupFor=='Discharge Summary'?"<link rel='stylesheet' href='/assets/css/dischargeSummary.scss'>":''
    styleUrl=styleUrl+chai;
    size = psDetails?.paperSize?.toUpperCase() + ' ' + psDetails?.orientation;
    if (psDetails?.paperSize == "custom") {
      height=null;
      width=null
      height=psDetails.height+"cm";
      width=psDetails.width+"cm"; 
      if(psDetails.height==15&&psDetails.width==15){//
        size = "auto";
        styleUrl = styleUrl + " " + "<link rel='stylesheet' href='/assets/css/a5landscape.css'>"
      }else{
        size = width +" "+ height;
        styleUrl = styleUrl + " " + "<link rel='stylesheet' href='/assets/css/printcustom.css'>"
      }  
      a5style=`
        .service
        {
          width: 150px;
        }    
        .print-table-padding th , .print-table-padding td {
          padding: 0.3rem !important;
        }
        .print-receipt-detail label span{
          font-weight: 600;
         }
         .print-address{
          width:90px !important;
          font-size:9px !important;
        }
        .doneby{
          width: 50px !important; 
        }
        .print-discont-text{
          width: 100px ;
        }
        .add-rreduce-paymenst
        {
          font-size: 10px;
        }
      `; 
    } else { 
      height="100%";
      width="99%"; 
      size = psDetails?.paperSize?.toUpperCase() + ' ' + psDetails?.orientation; 
      if (psDetails?.paperSize == "A5") {
        size = psDetails?.paperSize?.toUpperCase() + ' '+psDetails?.orientation;
        styleUrl = styleUrl + " " + "<link rel='stylesheet' href='/assets/css/printcustom.css'>"
        a5style=` 
          .table { 
              margin-bottom:0rem !important;
          }
         .print-receipt-detail table tr td strong{
           font-weight: 600;
           font-size:12px !important;
          }
          .print-receipt-detail table tr td {
            font-size:14px !important;
           }
           .print-discont-subtotal-bck .print-discont-text {
                font-size: 11px !important;
            }
            .print-discont-label {
              font-size: 10px !important;
            }
            .print-discont-subtotal-bck .print-grand-taotal {
              font-size: 11px !important;
            }
            .lessfont span {
              font-size: 9px !important;
            }
 
            .print-doctor-name-grand-total .print-discont-text {
                padding-top: 4px  !important;
                font-size: 10px !important;
            }
            .print-grand-taotal {
              font-size: 11px  !important;
            } 
            .print-discont-text{
              padding:5px !important;
            }
            
          .print-receipt-detail p {
            font-size: 9px !important;
            }
            .print-receipt-detail b {
            font-size: 10px !important;
            }
            .print-doctor-name-grand-total {
              margin-right: ${psDetails?.pageSetupFor=='IP Bill'?'-4px':'0px'} !important;
            }
            .net-amt {
              margin-right: -4px !important;
            }
            .print-address{
              width: ${psDetails?.pageSetupFor=='Advance Bill'?'80px':'180px'} !important;
              font-size:10px !important;
            }
            .print-discont-doctor-name {
              padding-top: 0px !important;
            }
            .doneby{
              width: 50px !important; 
            }
            .printadd{
              width:150px !important;
            }
            .print-discont-text{
              width: 100px ;
            } 
            .add-rreduce-paymenst
            {
              font-size: 10px;
            }
        `;
        
        if(this.tenantId==this.bloomTID && this.branchId==this.bloomBID){
          fontSize=12
          tblPadding='0.4';
          a5style=a5style+`
          .printer-dynamic-change .printer-hostital-logo img {
            max-height: 70px !important;
          }
          .printer-dynamic-change {
              height: 80px !important;
          }`;
        }
        else{
          fontSize=psDetails?.pageSetupFor=='IP Bill'?11:10.4
          tblPadding='0';
            a5style=a5style+`
            .printer-dynamic-change .printer-hostital-logo img {
              max-height: 70px !important;
            }
            .printer-dynamic-change {
                height: 60px !important;
            }`;
        }
      }else{
        a5style=`
         .print-receipt-detail label span{
           font-weight: 600;
           font-size:14px !important;
          }
          .print-receipt-detail label p{
            font-size:16px !important;
           }
           .print-doctor-name-grand-total .print-discont-text {
            padding-top: 4px  !important;
            font-size: 16px !important;
            }
            .print-grand-taotal {
              font-size: 16px  !important;
            } 
            .tblbar{
              height:35px
            }
            
          .print-receipt-detail b {
            font-size: 13px !important;
          }
          .print-doctor-name-grand-total {
            margin-right: 0px !important;
          }
          .print-address{
              width:130px !important;
              margin: 5px  !important;   
           }
           .lessfont span {
            font-size: 12px !important;
          }
        `;
      } 

      a5style=a5style+`
      .print-table-wa th , .print-table-wa td {
        width:auto;
        font-size: ${fontSize}px !important;
      }
      .print-table-padding td {
        padding: ${tblPadding}rem !important;
      }
      
      .print-table-bt th , .print-table-bt td {
        border-top: 0px solid #dee2e6;
      } 
      .printer-header h3 {
        position: relative;
        span{
          position: absolute;
        }
      }
      .printer-header .printdate{
        display:block;
        text-align: right;
          p{
              font-size: 11px;
              margin: 0px;
              margin-bottom: 4px;
          }
       }

       
        .print-discont-text {
          padding: 5px 5px  !important;
        }
        .print-discont-label {
          padding: 5px 5px !important;
        }

        .print-table-part h5{
          font-size:12px !important;
          margin: 5px  !important;
        }
        .add-rreduce-paymenst
        {
          font-size: 12px;
        }
        .print-table-padding-04 td {
          padding: 0.4rem !important;
        }
      `;
    }

    await this.sleep(100);
    this.openPrintWindow(content,psDetails,size,styleUrl,tblPadding,fontSize,a5style);
  }
  openPrintWindow(content,psDetails,size,styleUrl,tblPadding,fontSize,a5Style){
 
      var pageTitle = psDetails?.pageSetupFor!=null?psDetails?.pageSetupFor:"Print";
      let popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
      popupWin.document.open();
      var printContent=`
    <html> 
      <head>
      <title>${pageTitle}</title>
      ${styleUrl}
        <style> 
          @media print { 
            @page
            { 
              size: ${size} !important;
              margin: ${psDetails?.topMargin}px ${psDetails?.rightMargin}px ${psDetails?.bottomMargin}px ${psDetails?.leftMargin}px !important;
            }
            .share-th{ 
              display: none !important;
            }
            .action-table{
                display: none !important;
            }
            .print-display-none{
                display: none !important;
            }
            .bartext{
              font-size: 8px !important;
            }  
          }
        
          .print-receipt-detail label{
            margin-bottom: 10px !important;
            display: block;
           }
           ${a5Style}
         
          #nb1{ 
            position: absolute !important;
            margin-top: -10px !important;
           }
           .print-receipt-bill-details {
            padding-bottom: 1px;
           } 
           .sn_class{
              padding-bottom: 10px !important;
            }
            .donebytext{
              border-bottom: 0px solid #dee2e6 !important;
             }  
             ${this.caseSheetCss}    
             .tbl-lab td{
              vertical-align: bottom !important;   
            }
          }
          ${this.caseSheetCss}
          .footer-lab-lable{
            font-size: 14px !important;
            margin-top: 50px !important;
            text-transform: none !important;
          }
        </style>
      </head>
      <body onload="loadprint()">       
        <div class="print-content">
          ${content}
        </div>  
      </body>
      <script>
      var count=0;
      function loadprint() {
        count=0;
        window.print();
        if(count!=0){
          window.opener = self;
          window.close();
        }
      }
     
      (function() {
        var afterPrint = function() {
            count++;
            if(count==2){ 
              window.opener = self;
              window.close();
            }
        };
    
        if (window.matchMedia) {
            var mediaQueryList = window.matchMedia('print');
            mediaQueryList.addListener(function(mql) {
                if (!mql.matches) {
                  afterPrint();
                }else{
                  count=0;
                }
            });
        }
    
        window.onafterprint = afterPrint;
      }());
    </script>
    </html>` 
    popupWin.document.write(printContent);
    // popupWin.focus();
    // this.sleep(5000);
    popupWin.document.close();
    // popupWin.addEventListener('unload', () =>{
    //    console.log('closed')
    // });
  
    // popupWin.close();
    // popupWin.print();
      // var originalContents = document.body.innerHTML;
  
      // document.body.innerHTML = printContents;
  
      // window.print();
  
      // document.body.innerHTML = originalContents;
  
  }


  openBarPrintWindow(content,psDetails,size,styleUrl,tblPadding,fontSize,a5Style,barcodeWidth,barcodeHeight,tm?,lm?){
    var pageTitle = psDetails?.pageSetupFor!=null?psDetails?.pageSetupFor:"Print";
    let popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    var printContent=`
  <html> 
    <head>
    <title>${pageTitle}</title>
    ${styleUrl}
      <style> 
        @media print { 
          @page
          { 
            size: ${size} !important;
            margin: ${psDetails?.topMargin}px ${psDetails?.rightMargin}px ${psDetails?.bottomMargin}px ${psDetails?.leftMargin}px !important;
          }
          .sticker-print{
           height:${barcodeHeight}mm !important;
           width:${barcodeWidth}mm !important;
       
          }
          .sticker-padding{
            padding-top:${tm ? tm : 10}px !important;
            padding-left:${lm ? lm :10}px !important;
          }
          .preview-content{
            height:${barcodeHeight}mm !important;
          }
          .barcodeWidth{
            width:${barcodeWidth}mm !important;
          }
          .share-th{ 
            display: none !important;
          }
          .action-table{
              display: none !important;
          }
          .print-display-none{
              display: none !important;
          }
          .bartext{
            font-size: 8px !important;
          }  
        }
      
        .print-receipt-detail label{
          margin-bottom: 10px !important;
          display: block;
         }
         ${a5Style}
       
        #nb1{ 
          position: absolute !important;
          margin-top: -10px !important;
         }
         .print-receipt-bill-details {
          padding-bottom: 1px;
         } 
         .sn_class{
            padding-bottom: 10px !important;
          }
          .donebytext{
            border-bottom: 0px solid #dee2e6 !important;
           }  
           ${this.caseSheetCss}    
           .tbl-lab td{
            vertical-align: bottom !important;   
          }
        }
        ${this.caseSheetCss}
        .footer-lab-lable{
          font-size: 14px !important;
          margin-top: 50px !important;
          text-transform: none !important;
        }

    
       
      </style>
    </head>
    <body onload="loadprint()">     
     ${content}    
    </body>
    <script>
    var count=0;
    function loadprint() {
      count=0;
      window.print();
      if(count!=0){
        window.opener = self;
        window.close();
      }
    }
   
    (function() {
      var afterPrint = function() {
          count++;
          if(count==2){ 
            window.opener = self;
            window.close();
          }
      };
  
      if (window.matchMedia) {
          var mediaQueryList = window.matchMedia('print');
          mediaQueryList.addListener(function(mql) {
              if (!mql.matches) {
                afterPrint();
              }else{
                count=0;
              }
          });
      }
  
      window.onafterprint = afterPrint;
    }());
  </script>
  </html>` 
  popupWin.document.write(printContent);
  popupWin.document.close();


}

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  onGetPrinterSettings():PrinterSettings{
    return {
      "id": 0,
      "pageSetupFor": null,
      "paperSize": "A4",
      "orientation": "Portrait",
      "topMargin": 0,
      "bottomMargin": 0,
      "leftMargin": 0,
      "rightMargin": 0,
      "height": null,
      "width": null,
      "topHeaderRequired": false,
      "topHeaderLine1": "",
      "topHeaderLine2": null,
      "topHeaderLine3": "",
      "topHeaderLine4": "",
      "topHeaderLogoRequired": false,
      "topHeaderLogoPosition": "start center",
      "topHeaderPosition": "end center",
      "bottomFooterRequired": false,
      "bottomFooterLine1": "",
      "bottomFooterLine2": null,
      "bottomFooterLine3": "",
      "bottomFooterLine4": "",
      "bottomFooterLogoRequired": false,
      "bottomFooterLogoPosition": "start center",
      "bottomFooterPosition": "end center",
      "reportHeader": null,
      "reportFooter": null,
      "reportHeaderPlacement": "center center",
      "reportFooterPlacement": "center center",
      "digitalSignatureLocation": null,
      "templateName": null,
      "pageTitle": null,
      "tableTitle": null,
      "othersettings":this.getAllPrinterOtherSettings('opbill'),
      "regBarcodeId":true,
      "tenantId": null,
      "branchId": null,
      "qrCodeEnableFlag":'N',
      "qrCodePlacement":"start"
    };  
  }
  onSetPsData(psDetails:PrinterSettings):PrinterSettings{
    if(!!psDetails){
    psDetails.topHeaderLogoPosition="center "+psDetails?.topHeaderLogoPosition;
    psDetails.topHeaderPosition="center "+psDetails?.topHeaderPosition;
    psDetails.reportHeaderPlacement="center "+psDetails?.reportHeaderPlacement;
    psDetails.topHeaderLogoRequired=psDetails.topHeaderLogoRequired =="1" ? true : false;
    psDetails.topHeaderRequired=psDetails.topHeaderRequired =="1" ? true : false;
    psDetails.bottomFooterLogoPosition="center "+psDetails?.bottomFooterLogoPosition;
    psDetails.bottomFooterPosition="center "+psDetails?.bottomFooterPosition;
    psDetails.bottomFooterLogoRequired=psDetails.bottomFooterLogoRequired =="1" ? true : false;
    psDetails.bottomFooterRequired=psDetails.bottomFooterRequired =="1" ? true : false; 
    return psDetails;
    }
    else
     return this.onGetPrinterSettings();
  }

  getPrinterVisibleData(pageName){
    var branchData=JSON.parse(localStorage.getItem("branchAccessList"));
    var psSetting = JSON.parse(branchData.find(e=>e.id == localStorage.getItem("branchId"))?.printerRequiredFields?.toString());
    if(psSetting.hasOwnProperty(pageName)){
      return {
        qty : "required"==psSetting[pageName]?.qty?true:false,
        discount:"required"==psSetting[pageName]?.discount?true:false,
        referenceno: "required"==psSetting[pageName]?.referenceno?true:false,
        uhid:"required"==psSetting[pageName]?.uhid?true:false, 
        ageformat:"required"==psSetting[pageName]?.ageformat?true:false,
        doneby:"required"==psSetting[pageName]?.doneby?true:false,
        preparedbt:"required"==psSetting[pageName]?.preparedbt?true:false,
        status:"required"==psSetting[pageName]?.status?true:false,
        paymode:"required"==psSetting[pageName]?.paymode?true:false,
        attender:"required"==psSetting[pageName]?.attender?true:false,
        bedno:"required"==psSetting[pageName]?.bed_no?true:false,
        datas:psSetting[pageName]
      }
    }else{
      return {
        qty : true,
        discount:true,
        referenceno:true
      }
    }
  }
  ifNotPsSettings(data,pname){
    debugger
    if(pname=="OP Bill"){  
      if(!!data["opbill"])
      var opbill=data["opbill"];
      else if(!!data)
      var opbill=data; 

      var newJson={};
      if(!!!opbill["ageformat"])
          newJson["ageformat"] = "required";
      if(!!!opbill["uhid"])
        newJson["uhid"] = "required";
      if(!!!opbill["doneby"])
        newJson["doneby"] = "required";
      if(!!!opbill["preparedbt"])
        newJson["preparedbt"] = "required";
      if(!!!opbill["status"])
        newJson["status"] = "required";
      if(!!!opbill["paymode"])
        newJson["paymode"] = "required";
  
      return JSON.stringify({...opbill,...newJson})
      
    }
    else if(pname=="IP Bill"){  
      if(!!data["ipbill"])
      var ipbill=data["ipbill"];
      else if(!!data)
      var ipbill=data;

      var newJson={};
      if(!!!ipbill["inssummary"])
          newJson["inssummary"] = "required";
      if(!!!ipbill["uhid"])
        newJson["uhid"] = "required";
      if(!!!ipbill["doneby"])
        newJson["doneby"] = "required";
      if(!!!ipbill["preparedbt"])
        newJson["preparedbt"] = "required";
      if(!!!ipbill["status"])
        newJson["status"] = "required";
      if(!!!ipbill["ageformat"])
        newJson["ageformat"] = "required";
      if(!!!ipbill["paymode"])
        newJson["paymode"] = "required";  
      if(!!!ipbill["attender"])
        newJson["attender"] = "required";  
      if(!!!ipbill["bedno"])
        newJson["bedno"] = "required";  
      return JSON.stringify({...ipbill,...newJson}) 
    }else if(pname=="Advance Bill"){  
      if(!!data["advance"])
        var advancebill=data["advance"];
      else if(!!data)
        var advancebill=data; 

      // var advancebill=data["advance"];
      var newJson={};
      if(!!!advancebill["preparedbt"])
        newJson["preparedbt"] = "required";
      if(!!!advancebill["uhid"])
        newJson["uhid"] = "required";
      return JSON.stringify({...advancebill,...newJson}) 
    }else{
      return JSON.stringify(data)
    } 
  }
  setVisibleHideOption(data):any{   
    this.objectKeys(data).forEach(element=>{       
      data[element]=data[element]=="required"?true:false;
    }) 
    
    return {...data,...{datas:data}};
  }
  getAllPrinterOtherSettings(pname){
    var branchData=JSON.parse(localStorage.getItem("branchAccessList"));
    return JSON.parse(branchData.find(e=>e.id == localStorage.getItem("branchId"))?.printerRequiredFields)
  }
  caseSheetCss=`
  #caseSheetSumDia ul{
    margin-block-end: 0.5em;
    margin-block-start: 0.5em;
  } 
  #caseSheetSumDia .block-heading-ehr { 
    padding-bottom: 10px !important;
    text-decoration: none !important;
    font-weight:600;
  }
  
  #caseSheetSumDia .block-heading-ehr label{
    text-decoration: none !important;
    text-underline-position: unset !important;
  }
  #caseSheetSumDia .block-heading-ehr .datadis{
    text-decoration: none;
  }
  #caseSheetSumDia .datadis{
    color: #333333;
  }
  #caseSheetSumDia .medical-history-dialog-block {  
    padding-bottom: 10px !important;
  }   
  #caseSheetSumDia  .datadis{
       color: #333333;
       font-weight: 600;
       text-decoration: none;
       text-underline-position: unset;
       
   }
   #caseSheetSumDia .val{
       font-weight: 500 !important;
       color: #615454;
   } 
   .summary-dialog-box .tab-block-conetnts {
    border-bottom: 0px solid #e5e5e5 !important;
    margin-bottom: 2px  !important;
   }
   #caseSheetSumDia .table {
    margin-bottom: 0px  !important;
   }
   #caseSheetSumDia .table th {
    padding: 0.3rem  !important;
   }
   #caseSheetSumDia .table td {
    padding: 0.3rem  !important;
    font-size: 14px !important;
   }
   #caseSheetSumDia td h4{ 
      margin: 0 !important;
      padding: 0 !important;
   }
   #caseSheetSumDia .display-flex-div{
    display: flex !important;
    }
    
  `;
  casheetStyle=`
  
  .vitaluL ul li{
    width: 24.3%;            
    margin-bottom: 1.5px !important;
    padding-bottom: 1.5px !important;
  }
  #caseSheetSumDia .vitaluL ul li label span{ 
      font-weight: 600;
      color: black;
  }          
  #caseSheetSumDia .medical-history-dialog-block {  
    padding-bottom: 2px !important;
  }
  #caseSheetSumDia .summary-dialog-box .tab-block-conetnts{
    padding-bottom: 2px !important;
    margin-bottom: 1px !important;
  } 
  #caseSheetSumDia .summary-dialog-box .tab-block-conetnts{
    padding-bottom: 2px !important;
    margin-bottom: 1px !important;
  }
  #caseSheetSumDia .print-receipt-bill-details {
    padding-bottom: 0px !important;
  }
  #caseSheetSumDia ul{
    margin-block-end: 0.5em;
    margin-block-start: 0.5em;
  } 
  #caseSheetSumDia .block-heading-ehr {
    text-decoration: none;
  }
  #caseSheetSumDia .block-heading-ehr label{
    text-decoration: underline;
    text-underline-position: under;
  }
  #caseSheetSumDia .block-heading-ehr .datadis{
    text-decoration: none;
  }
  #caseSheetSumDia .datadis{
    color: #333333;
  }
  #caseSheetSumDia .print-receipt-bill-details {
    padding-bottom: 0px !important;
  }
  #caseSheetSumDia .table td{
    padding:0.1rem  !important;
    border-left: 0px solid #e6e6e6 !important;
    border-top: 0px solid #e6e6e6 !important; 
    border-right: 0px solid #e6e6e6 !important; 
  }
  #caseSheetSumDia table th {
    padding:0.1rem  !important;
    border-bootom: 1px solid #e6e6e6 !important;
    border-top: 1px solid #e6e6e6 !important; 
  }`;
}







